import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Divider,
  Button,
  Stack,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";

export default function OpsRelationshipsPage() {
  const pageTitle = "Workspaces";
  usePageTitle(pageTitle);
  const { ref } = useParams();

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [relationships, setRelationships] = useState([]);
  const [account, setAccount] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/ops/${ref}/relationships.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAccount(result.data.data.account);
            setRelationships(result.data.data.relationships);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox ml={-2} mb={1} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              onClick={() => window.history.back()}
              startIcon={<Icon>west</Icon>}
              color="dark"
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        <MDBox mb={3}>
          <Card>
            <MDBox p={2}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                px={1}
                alignItems="center"
              >
                <MDBox pt={0.5}>
                  <Icon>workspaces</Icon>
                </MDBox>
                <MDBox>
                  <MDBox align="right">
                    <MDTypography
                      variant="body2"
                      fontWeight="light"
                      fontSize={10}
                    >
                      ORGANISATION
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      fontWeight="regular"
                      fontSize={15}
                    >
                      {account.title}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={0}>
          {relationships.length > 0 ? (
            <Stack display="flex" gap={2}>
              {relationships.map((relationship) => (
                <MDBox
                  onClick={() => {
                    navigate(
                      `/ops/workspaces/${relationship.reference}/entities`,
                    );
                  }}
                >
                  <Card>
                    <MDBox p={1.5}>
                      <MDBox pt={0.5}>
                        <Icon>business</Icon>
                      </MDBox>
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            fontWeight="bold"
                            fontSize={15}
                          >
                            {relationship.title}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Icon>east</Icon>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </Stack>
          ) : (
            <Card>
              <MDBox align="center" p={2}>
                <MDTypography fontSize={48}>
                  <Icon>warning</Icon>
                </MDTypography>
                <MDTypography variant="body2">
                  Your workspace is empty. Contact your organisation's support
                  team.
                </MDTypography>
              </MDBox>
            </Card>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
